import axios from "./axiosConfig.js";

export const syncPositions = async (syncOptions) => {
  return await axios.post("/positions/sync", syncOptions);
};

export const getMovingTrafficData = async (params) => {
  return await axios.get("/positions/moving-traffic", { params });
};

// Nueva función para obtener las vías más transitadas por provincia
export const getMostTransitedStreetsByProvince = async (params) => {
  return await axios.get("/positions/most-transited-streets", { params });
};
